// extracted by mini-css-extract-plugin
export var alert = "ArticleSidebar-module--alert--0aeRR";
export var component = "ArticleSidebar-module--component--s1JPp";
export var hideExternal = "ArticleSidebar-module--hideExternal--IGSL-";
export var shareLink = "ArticleSidebar-module--shareLink--efLrK";
export var shareLinkListItem = "ArticleSidebar-module--shareLinkListItem--EoJif";
export var shareLinks = "ArticleSidebar-module--shareLinks--IVvhl";
export var title = "ArticleSidebar-module--title--P+Vz0";